import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';

export const useCapacitorApp = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Apenas executa em ambiente nativo Capacitor (iOS / Android)
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    // 1. Configurar Barra de Status Nativa
    const setupStatusBar = async () => {
      try {
        await StatusBar.setStyle({ style: Style.Dark });
        if (Capacitor.getPlatform() === 'android') {
          await StatusBar.setBackgroundColor({ color: '#202529' });
        }
      } catch (err) {
        console.warn('Erro ao configurar StatusBar:', err);
      }
    };

    // 2. Esconder a SplashScreen nativa com fade suave
    const hideSplashScreen = async () => {
      try {
        await SplashScreen.hide({ fadeOutDuration: 400 });
      } catch (err) {
        console.warn('Erro ao ocultar SplashScreen:', err);
      }
    };

    // 3. Configurar comportamento do Teclado Virtual
    const setupKeyboard = async () => {
      try {
        await Keyboard.setResizeMode({ mode: KeyboardResize.Body });
      } catch (err) {
        console.warn('Erro ao configurar Keyboard:', err);
      }
    };

    setupStatusBar();
    hideSplashScreen();
    setupKeyboard();

    // 4. Gerenciador do Botão Nativo Voltar (Android Hardware Back Button)
    const backListener = App.addListener('backButton', ({ canGoBack }) => {
      // Se estiver na tela inicial, fecha o aplicativo
      if (location.pathname === '/' || location.pathname === '') {
        App.exitApp();
      } else if (canGoBack) {
        window.history.back();
      } else {
        navigate('/');
      }
    });

    return () => {
      backListener.then((handler) => handler.remove()).catch(() => {});
    };
  }, [location.pathname, navigate]);
};
